/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/PyramidAuthority',['lodash',
        'absolute/debug',
        'util/dictionary',
        'SolitaireShared/CardLogic/IGameAuthority',
        'SolitaireShared/CardLogic/TipEventArgs',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/CardLogic/Card',
        'SolitaireShared/CardLogic/Pile',
        'SolitaireShared/CardLogic/CardValue',
        'SolitaireShared/CardLogic/CardSuit',
        'SolitaireShared/CardLogic/CardColor',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/CardAction',
        'SolitaireShared/CardLogic/MoveState',
        'SolitaireShared/CardLogic/DealData',
        'util/eventhandler'],
    function (_, Debug, Dictionary, IGameAuthority, TipEventArgs, Supply, Card, Pile, CardValue, CardSuit, CardColor, CardOp, CardAction, MoveState, DealData, EventHandler) {
        "use strict";

        var PyramidAuthority = function () {
            this.initPyramidAuthority();
        };

        PyramidAuthority.constructor = PyramidAuthority;
        PyramidAuthority.prototype = Object.create(IGameAuthority.prototype);

        PyramidAuthority.prototype.initPyramidAuthority = function () {
            this.CardSupply = new Supply("Pyramid");
            this.CardSupply.Authority = this;
            this.MaxDeals = 3;
            this.SuppressBonusAnimations = false;

            this.IsChallenge = false;

            this._lastHint = null;

            this.DealScript = PyramidAuthority.DefaultDealScript;

            this.WinSetAction = null;

            this.CardsClearedWerePeaks = [];

            this._currentConsecutiveCardsClearedWithStock = 0;
            this.MaxConsecutiveCardsClearedWithStock = 0;

            this._currentWasteCardsUsed = 0;
            this.MaxWasteCardsUsed = 0;

            this.CurrentDeal = 0;
            this.TotalDeals = 0;
            this.FreeDeals = 0;

            this.NumBoardsCompleted = 0;

            this.WonWithKing = false;

            this.Matches = 0;
            this.RowsCleared = 0;

            this.PassesThroughDeck = 0;
            this._redealing = false;

            this.ShowOutOfMovesTip = true;

            this.DealScript = PyramidAuthority.DefaultDealScript;

            this.onBonusEffectEventHanlder = new EventHandler();
        };

        Object.defineProperty(PyramidAuthority.prototype, "MAX_DEALS", {
            get: function () {
                return this.MaxDeals;
            }
        });

        PyramidAuthority.MaxPassesThroughDeck = 3;

        // TODO
        //    public event OnTipEventHandler OnTip;
        //    public event OnBonusEffectEventHandler OnBonusEffect;
        //    public event OnAuthorityDealEventHanlder OnDealEvent;
        //    public event EventHandler BoardCleared;


        var TagMatch = 0x1;
        var TagRowclear = 0x2;
        var TagPassthroughdeck = 0x4;


        //Dictionary<int, Pile> _numToTableau;
        //Dictionary<Pile, int> _tableauToNum;

        PyramidAuthority.prototype.Setup = function () {
            this.CardSupply.AddPile("DealStock", "Stock"); // face down pile for dealing only

            this.CardSupply.AddPile("Stock", "Stock");
            this.CardSupply.AddPile("Waste", "Waste");
            this.CardSupply.AddPile("Joker", "Joker");

            this.CardSupply.AddPile("Foundation", "Foundation");

            this.CardSupply.AddPile("Free", "Free"); // optional?

            this._numToTableau = new Dictionary(Number, Pile);
            this._tableauToNum = new Dictionary(Pile, Number);

            for (var i = 0; i < 28; i++) {
                var pileID = this.CardSupply.AddPile("Tableau" + i, "Tableau");
                var pile = this.CardSupply.GetPile(pileID);
                this._numToTableau.Add(i, pile);
                this._tableauToNum.Add(pile, i);
            }



            this.CurrentDeal = 0;
            this.Matches = 0;
            this.RowsCleared = 0;
            this.NumBoardsCompleted = 0;
            this.TotalDeals = this.MAX_DEALS;
            this.FreeDeals = 0;
            this.WonWithKing = false;

            this.CardSupply.CreateCards(1, 4, 1);
        };

        PyramidAuthority.prototype.Reset = function () {
            this.CardSupply.ResetGame();

            this.RemoveWildCards();

            this.MaxConsecutiveCardsClearedWithStock = 0;
            this._currentConsecutiveCardsClearedWithStock = 0;

            this.MaxWasteCardsUsed = 0;
            this._currentWasteCardsUsed = 0;

            this.CurrentDeal = 0;
            this.Matches = 0;
            this.RowsCleared = 0;
            this.NumBoardsCompleted = 0;
            this.TotalDeals = this.MAX_DEALS;
            this.FreeDeals = 0;
        };

        PyramidAuthority.prototype.RemoveWildCards = function () {
            var wildPile = this.CardSupply.GetPile("Joker");
            if (wildPile != null)
                wildPile.ClearCards();
        };

        PyramidAuthority.prototype.OnBoardCleared = function () {
            var handler = this.BoardCleared;
            if (handler != null) handler.handeEvent(this/* TODO , EventArgs.Empty */);
        };

        PyramidAuthority.prototype.BoardsCompleted = function () {
            return this.NumBoardsCompleted;
        };

        PyramidAuthority.prototype.NumDealsLeft = function () {
            return this.TotalDeals - this.CurrentDeal;
        };


        PyramidAuthority.prototype.ShuffleNumberToString = function (dealNum) {
            return "+SHUFFLE_" + dealNum;
        };

        PyramidAuthority.prototype.GetIthDeckSeed = function (i) {
            return this.CardSupply.GetOption(this.ShuffleNumberToString(i));
        };


        PyramidAuthority.prototype.Deal = function () {
            if (this.OnDealEvent != null)
                this.OnDealEvent();

            // Get the number of deals we've done so far.
            this.CurrentDeal = this.CardSupply.NumDealsSoFar();
            this.PassesThroughDeck = 0;

            var userWonBoard = false;
            if (this.CurrentDeal != 0)
                userWonBoard = this.CheckWin();

            if (!userWonBoard && this.CurrentDeal >= this.TotalDeals)
                return false;

            this.CardSupply.PrepareGame(false);

            var deckSeed = this.CurrentDeal == 0 ? this.CardSupply.DeckSeed : this.GetIthDeckSeed(this.CurrentDeal);

            if (this.CardSupply.CardAnimator != null) {
                this.CardSupply.CardAnimator.BeginShuffleAnimation();
            }

            var originalSeed = deckSeed;
            deckSeed = this.CardSupply.RootPile.Shuffle(deckSeed);
            // now log the deal we just did.
            if (originalSeed != deckSeed) {
                if (this.CurrentDeal == 0) {
                    this.CardSupply.DeckSeed = deckSeed;
                }
                else {
                    var optionAction = new CardAction(this.CardSupply);
                    optionAction.Parse(["OPTION", this.ShuffleNumberToString(this.CurrentDeal), deckSeed]);
                    optionAction.Run();
                    this.CardSupply.LogAction(optionAction);
                }
            }

            // create new Option action for this deck seed and add to log?

            Debug.log("CardSupply.DeckSeed = " + this.CardSupply.DeckSeed);

            this.CardSupply.OnShuffleCards();

            // Don't enforce game rules or log moves during deal. This usually already happens in PrepareGame(true).
            this.CardSupply.EnforceGameRules = this.CardSupply.LogMoves = false;
            CardAction.RunActions(this.CardSupply, this.DealScript);

            // StartGame() inits the action log with the game and options,
            // don't do that if this is the second or third deal.
            if (this.CurrentDeal == 0) {
                this.CardSupply.StartGame();
            }
            else {
                this.CardSupply.LogMoves = true;

                this.CardSupply.LogAction(CardAction.sParse(this.CardSupply, ["DEAL", deckSeed]));
                this.CardSupply.ForceDealEvent();

                this.CardSupply.EnforceGameRules = true;
            }

            if (userWonBoard) {
                this.TotalDeals++;
                this.FreeDeals++;
                this.OnBoardCleared();
            }

            this.CurrentDeal = this.CardSupply.NumDealsSoFar();

            this._redealing = false;
            return true;
        };

        PyramidAuthority.prototype.Tick = function (playedTime) {
        };


        /* 					    	0
         * 				    	1		2
         * 			    	3		4		5
         * 		    	6		7		8		9
         * 	    	10		11		12		13		14
         *  	15		16		17		18		19		20
         * 21		22		23		24		25		26		27
         */

        // This is a list of which tableau numbers are blocking which other tableau numbers
        var TableauBlockers = [
            [ 1, 2], // tableaus blocking 0
            [ 3, 4], // 1
            [ 4, 5], // 2
            [ 6, 7], // 3
            [ 7, 8], // 4
            [ 8, 9], // 5
            [10, 11], // 6
            [11, 12], // 7
            [12, 13], // 8
            [13, 14], // 9
            [15, 16], // 10
            [16, 17], // 11
            [17, 18], // 12
            [18, 19], // 13
            [19, 20], // 14
            [21, 22], // 15
            [22, 23], // 16
            [23, 24], // 17
            [24, 25], // 18
            [25, 26], // 19
            [26, 27] // 20
        ];

        PyramidAuthority.prototype.GetTableauNum = function (tableau) {
            if (this._tableauToNum.ContainsKey(tableau))
                return this._tableauToNum.Get(tableau);
            return -1;
        };

        PyramidAuthority.prototype.GetTableau = function (tableauNum) {
            if (this._numToTableau.ContainsKey(tableauNum))
                return this._numToTableau.Get(tableauNum);
            return null;
        };

        var TopRow = 6;

        PyramidAuthority.prototype.GetRow = function (pile) {
            var num = this.GetTableauNum(pile);
            if (num < 0) return -1;
            if (num < 1) return 0;
            if (num < 3) return 1;
            if (num < 6) return 2;
            if (num < 10) return 3;
            if (num < 15) return 4;
            if (num < 21) return 5;
            return 6;
        };

        PyramidAuthority.prototype.IsTableauBlocked = function (pile) {
            if (pile.Type != "Tableau") return false;

            var row = this.GetRow(pile);
            var num = this.GetTableauNum(pile);

            if (row == TopRow || num > 20) return false;


            var blocker0 = this.GetTableau(TableauBlockers[num][0]);
            var blocker1 = this.GetTableau(TableauBlockers[num][1]);

            if (blocker0 != null && !blocker0.Empty) return true;
            if (blocker1 != null && !blocker1.Empty) return true;

            return false;
        };

        PyramidAuthority.prototype.IsActionAllowed = function (action, triggerTips) {
            if (action == null || action.Ops == null || action.Ops.length == 0)
                return false;

            var op = action.Ops[0];
            if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Undo) {
                // always allow an undo by itself
                return true;
            }

            if (action.IsNoop()) {
                // always allow a no-op action
                return true;
            }

            if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Game) {
                // always allow the game to be started
                return true;
            }

            if (op.Opcode == CardOp.Op.TotalDealsExtra) {
                return true;
            }

            if (op.Opcode == CardOp.Op.WildCardAdd) {
                return true;
            }

            if (action.Ops.length == 1) {
                if (op.Opcode == CardOp.Op.Move) {
                    var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
                    var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
                    var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

                    // allowed to move:
                    // 1 card from stock to waste
                    // 1 king from waste to foundation
                    // 1 king from tableau to foundation if not blocked

                    if (sourcePile.Type == "Stock" && destPile.Type == "Waste") {
                        if (numCards == 1 && !sourcePile.Empty && !this.CheckWin()) // make sure they didn't win the board
                            return true;
                    }
                    else if (sourcePile.Type == "Waste" && destPile.Type == "Stock") {
                        var dealsLeft = (this.PassesThroughDeck < PyramidAuthority.MaxPassesThroughDeck - 1);

                        var retval = (numCards < 0 &&
                            destPile.Empty &&
                            sourcePile.Count == -numCards &&
                            dealsLeft);

                        return retval;
                    }
                    else if ((sourcePile.Type == "Tableau" || sourcePile.Type == "Waste" || sourcePile.Type == "Stock")
                        && destPile.Type == "Foundation") {
                        if (numCards == 1 && !sourcePile.Empty && !this.IsTableauBlocked(sourcePile) &&
                            sourcePile.Top.Value == CardValue.Values.King) {

                            var blocker0 = this.GetTableau(TableauBlockers[0][0]);
                            var blocker1 = this.GetTableau(TableauBlockers[0][1]);

                            if (this.GetTableau(0).Count == 1 && blocker0.Empty && blocker1.Empty) {
                                this.WonWithKing = true;
                            }
                            return true;
                        }
                    }
                    // additional rule for moving a card to the Free spot
                }
                else if (op.Opcode == CardOp.Op.Deal) {
                    // For the 2nd+ deals, EnforceGameRules will be true so we need to allow this op.
                    // Makes sure that the subsequent deals are the same as the seeds set in the options.
                    var seed = op.GetDeck(CardOp.eDealParams.DeckSeed);

                    // see how many decks we've dealt so far
                    var numDeals = this.CardSupply.NumDealsSoFar();

                    // check the saved deck seed for the next deal #
                    if (seed == this.CardSupply.GetOption(this.ShuffleNumberToString(numDeals)))
                        return true;
                    return false;
                }
            }
            else if (action.Ops.length == 2) {
                var opB = action.Ops[1];
                if (op.Opcode == CardOp.Op.Move && opB.Opcode == CardOp.Op.Move) {
                    var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
                    var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
                    var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

                    var sourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
                    var destPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
                    var numCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

                    if (this.CheckWin())
                        return false; // disallow matching if we have already won the board.

                    // allowed to move:
                    // card from tableau/waste and another card from tableau/waste, both to foundation, if they add up to 13
                    if ((sourcePile.Type == "Tableau" || sourcePile.Type == "Waste" || sourcePile.Type == "Stock" || sourcePile.Type == "Joker")
                        && destPile.Type == "Foundation" &&
                        (sourcePileB.Type == "Tableau" || sourcePileB.Type == "Waste" || sourcePileB.Type == "Stock" || sourcePileB.Type == "Joker")
                        && destPileB.Type == "Foundation") {
                        if (numCards == 1 && numCardsB == 1 && !sourcePile.Empty && !sourcePileB.Empty &&
                            sourcePile != sourcePileB && !this.IsTableauBlocked(sourcePile) && !this.IsTableauBlocked(sourcePileB)) {
                            if (sourcePile.Top.ValueNum + sourcePileB.Top.ValueNum == 13)
                                return true;

                            if (sourcePile.Top.Value == CardValue.Values.Joker || sourcePileB.Top.Value == CardValue.Values.Joker)
                                return true;
                        }

                        if (triggerTips && this.OnTip != null)
                            this.OnTip(this, new TipEventArgs("Tips_Pyramid_Match"));
                    }
                    // additional checks in the above rule to allow using the free spot
                }
            }
            return false;
        };

        PyramidAuthority.prototype.CanAutoSolve = function () {
            return false;
        };

        PyramidAuthority.prototype.CanKeyboardFocusCard = function (card) {
            if (!this.CanPickupCard(card))
                return false;
            if (card.Pile.Type == "Tableau")
                return !this.IsTableauBlocked(card.Pile);
            return true;
        };

        PyramidAuthority.prototype.CanPickupCard = function (card) {
            if (this.CardSupply.WaitingForBlockingAnimation)
                return false;

            return card.Pile.Type == "Tableau" ||
                card.Pile.Type == "Waste" ||
                card.Pile.Type == "Free";

        };

        PyramidAuthority.prototype.CanAcceptCards = function (pile) {
            if (pile.Type == "Free")
                return true;
            return false;
        };

        PyramidAuthority.prototype.IsGameWon = function () {
            if (this.CardSupply.WaitingForAnimation) {
                // We don't win unless the card animation is finished.
                return false;
            }
            if (this.CheckWin()) {
                this.WriteSolvableDeckLog();
                this.Deal();
            }
            return false;
        };

        PyramidAuthority.prototype.WriteSolvableDeckLog = function () {
            /*
             #if WRITE_SOLVABLE_DECKS
             if (!IsChallenge)
             {
             FileManager.Current.WriteTextFileAsync(
             "Game: Pyramid\nSeed: " + CardSupply.DeckSeed,
             "PyramidSolvableDeck_" + DateTime.Now.ToString().Replace('/', '-').Replace(':', '.') + ".log",
             FileSource.StorageFiles);
             }
             #endif
             */
        };

        PyramidAuthority.prototype.CheckWin = function () {
            if (this.GetTableau(0).Count == 0) {
                return true;

            }
            return false;
        };

        PyramidAuthority.prototype.GetCompletedStacks = function () {
            return 0;
        };

        /* 					    	0
         * 				    	1		2
         * 			    	3		4		5
         * 		    	6		7		8		9
         * 	    	10		11		12		13		14
         *  	15		16		17		18		19		20
         * 21		22		23		24		25		26		27
         */


        PyramidAuthority.prototype.GetScoreForAction = function (action) {
            var appliedBonus = false;
            var appliedPoints = false;
            var score = 0;

            var rowLayout = [
                [0, 0],
                [1, 2],
                [3, 5],
                [6, 9],
                [10, 14],
                [15, 20],
                [21, 27]
            ];

            var bonuses = [
                500,
                250,
                150,
                100,
                75,
                50,
                25
            ];

            // Maps row number to bonus effect for that row.
            // Ensures that each row has at most one effect triggered.
            var bonusEffects = [];

            for (var i = 0; i < action.Ops.length; i++) {
                var op = action.Ops[i];

                if (op.Opcode == CardOp.Op.Move &&
                    op.GetPile(CardOp.eMoveParams.DestPile).Type == "Foundation") {
                    var tableau = this.GetTableauNum(op.GetPile(CardOp.eMoveParams.SourcePile));

                    if (!appliedPoints) {
                        score += 5;
                        appliedPoints = true;
                    }

                    if (!appliedBonus) {
                        // Determine the amount of bonus points for this op (if any).
                        var bonus = 0;
                        var r;
                        for (r = 0; r < rowLayout.length && bonus <= 0; r++) {
                            var row = rowLayout[r];

                            // If the pile is within this row...
                            if (tableau >= row[0] && tableau <= row[1]) {
                                // And each pile in the row is empty...
                                for (var j = row[0]; j <= row[1]; j++) {

                                    if (j != tableau && !this.GetTableau(j).Empty) {
                                        break;
                                    }
                                    else if (j == row[1]) {
                                        // If all piles of this row is empty, we earned a bonus!
                                        bonus = bonuses[r];
                                        //RowsCleared++;

                                        action.Tag = (action.Tag | TagRowclear) >>> 0;
                                        break;
                                    }
                                }
                            }
                        }

                        r--; // r = row number.

                        /*if (chainIsActive)
                         bonus *= 2;*/

                        if (bonus > 0) {
                            appliedBonus = true;
                            var tableausToLeft = [];
                            for (var i = tableau - 1; i >= rowLayout[r][0]; i--)
                                tableausToLeft.push(i);

                            var tableausToRight = [];
                            for (var i = tableau + 1; i <= rowLayout[r][1]; i++)
                                tableausToRight.push(i);

                            score += bonus;

                            bonusEffects.push({
                                    'pile': op.GetPile(CardOp.eMoveParams.SourcePile),
                                    'bonus': bonus,
                                    'tableausToLeft': tableausToLeft,
                                    'tableausToRight': tableausToRight,
                                    'isPerfect': r == 0,
                                    'row': rowLayout.length - r
                                });
                        }
                    }
                }
                else if (op.Opcode == CardOp.Op.Move
                    && op.GetPile(CardOp.eMoveParams.SourcePile).Type == "Waste"
                    && op.GetPile(CardOp.eMoveParams.SourcePile).Count == 0) {
                    action.Tag = (action.Tag | TagPassthroughdeck) >>> 0;
                }
                else if (op.Opcode == CardOp.Op.Undo) {
                    return 0;
                }

                if (!this._redealing && this.CardSupply.GetPile("Tableau0").Empty && this.CardSupply.RootPile.Count == 0) {
                    this._redealing = true;
                    this.NumBoardsCompleted++;
                    this.CardSupply.OnBoardCompletedEvent.handleEvent(this.NumBoardsCompleted);
                }
            }

            for (var i = 0; i < bonusEffects.length; i++) {
                if (this.onBonusEffectEventHanlder != null && bonusEffects[i] != null && this.SuppressBonusAnimations == false){
                    this.onBonusEffectEventHanlder.handleEvent(this, bonusEffects[i]);
                }

            }

            if (score > 0) {
                action.Tag = (action.Tag | TagMatch) >>> 0;
            }

            return score;
        };

        PyramidAuthority.prototype.GetScoreForTimer = function (currTimer, prevTimer) {
            if (this.CardSupply.IsTimerCountdown)// && currTimer != prevTimer)
            {
                return Math.max((1000 - (this.CardSupply.CurrentTime * 10)), 0);
            }
            return 0;
        };

        PyramidAuthority.prototype.GetBonusScore = function (totalTimer) {
            return 0;
        };

        PyramidAuthority.prototype.GetMaxScore = function () {
            return Number.MAX_VALUE;
        };

        PyramidAuthority.prototype.GetMinScore = function () {
            return 0;
        };

        PyramidAuthority.prototype.GetStartingScore = function () {
            return 0;
        };

        PyramidAuthority.prototype.GetStartingTime = function () {
            var useTimer = parseInt(this.CardSupply.GetOption("PyramidTimer"));

            if (isNaN(useTimer))
                return 150;
            return 0;
        };


        PyramidAuthority.prototype.GetHint = function (cycle) {
            cycle = !!cycle;
            return this.GetHintInternal(cycle);
        };

        PyramidAuthority.prototype.GetHintInternal = function (cycle) {
            cycle = !!cycle;

            var numTableaus = 28;

            var hints = [];

            var a, b;
            this.CardSupply.GetPile("Foundation");

            // Tableau-a-tableau matches first.
            for (var i = numTableaus - 1; i >= 0; i--) {
                a = this.CardSupply.GetPile("Tableau" + i);
                if (a.Empty || this.IsTableauBlocked(a))
                    continue;

                // Shortcut if we find an unblocked King.
                if (a.Top.Value == CardValue.Values.King) {
                    // Note: the actually legal move would be a-to-foundation
                    // but the foundation is invisible in Pyramid.
                    var hint = new CardOp(this.CardSupply);
                    var args = [ "MOVE", a.Name, a.Name, "1" ];
                    hint.Parse(args, 0);
                    hints.push(hint);

                    continue;
                }

                for (var j = i - 1; j >= 0; j--) {
                    b = this.CardSupply.GetPile("Tableau" + j);
                    if (b.Empty || this.IsTableauBlocked(b))
                        continue;

                    if (a.Top.ValueNum + b.Top.ValueNum == 13) {
                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", a.Name, b.Name, "1" ];
                        hint.Parse(args, 0);
                        hints.push(hint);
                    }
                }

                var joker = this.CardSupply.GetPile("Joker");
                if (joker.GetCards().length > 0) {
                    var hint = new CardOp(this.CardSupply);
                    var args = [ "MOVE", a.Name, joker.Name, "1" ];
                    hint.Parse(args, 0);
                    hints.push(hint);
                }
            }

            if (!cycle && hints.length > 0)
                return hints[0];

            // Stock-a-waste matches second.
            a = this.CardSupply.GetPile("Stock");
            if (!a.Empty) {
                b = this.CardSupply.GetPile("Waste");
                if (!b.Empty) {
                    if (a.Top.ValueNum + b.Top.ValueNum == 13) {
                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", a.Name, b.Name, "1" ];
                        hint.Parse(args, 0);
                        hints.push(hint);
                    }
                }
            }

            if (!cycle && hints.length > 0)
                return hints[0];

            // Stock-a-tableau matches third.
            a = this.CardSupply.GetPile("Stock");
            if (!a.Empty) {
                for (var i = numTableaus - 1; i >= 0; i--) {
                    b = this.CardSupply.GetPile("Tableau" + i);
                    if (b.Empty || this.IsTableauBlocked(b))
                        continue;

                    if (a.Top.ValueNum + b.Top.ValueNum == 13) {
                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", a.Name, b.Name, "1" ];
                        hint.Parse(args, 0);
                        hints.push(hint);
                    }
                }
            }

            if (!cycle && hints.length > 0)
                return hints[0];

            // Waste-a-tableau matches fourth.
            a = this.CardSupply.GetPile("Waste");
            if (!a.Empty) {
                for (var i = numTableaus - 1; i >= 0; i--) {
                    b = this.CardSupply.GetPile("Tableau" + i);
                    if (b.Empty || this.IsTableauBlocked(b))
                        continue;

                    if (a.Top.ValueNum + b.Top.ValueNum == 13) {
                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", a.Name, b.Name, "1" ];
                        hint.Parse(args, 0);
                        hints.push(hint);
                    }
                }
            }

            if (!cycle && hints.length > 0)
                return hints[0];

            // Otherwise, stock-a-waste.
            var dealsLeft = this.IsDeckPassesAvailable();

            if (!this.CardSupply.GetPile("Stock").Empty || dealsLeft) {
                var hint = new CardOp(this.CardSupply);
                var args = [ "MOVE", "Stock", "Stock", "1" ];
                hint.Parse(args, 0);
                hints.push(hint);
            }

            if (!cycle && hints.length > 0)
                return hints[0];

            if (hints.length > 0) {
                if (!cycle) {
                    return hints[0];
                }
                else if (cycle) {
                    if (this._lastHint != null) {
                        // Find the position of the last hint in the hint list (if possible).
                        var index;
                        for (index = 0; index < hints.length; index++) {
                            if (hints[index].Equals(this._lastHint))
                                break;
                        }

                        if (index >= hints.length - 1) {
                            var hint = hints[0];
                            this._lastHint = hint;
                            return hint;
                        }
                        else {
                            var hint = hints[index + 1];
                            this._lastHint = hint;
                            return hint;
                        }
                    }
                    else {
                        var hint = hints[0];
                        this._lastHint = hint;
                        return hint;
                    }
                }
            }

            return new CardOp(this.CardSupply);
        };

        PyramidAuthority.prototype.IsDeckPassesAvailable = function () {
            if (this.PassesThroughDeck < PyramidAuthority.MaxPassesThroughDeck - 1) {
                if (this.CardSupply.GetPile("Stock").Empty && this.CardSupply.GetPile("Waste").Empty) {
                    return false;
                }
                return true;
            }
            return false;
        };

        PyramidAuthority.prototype.GetAutomaticMove = function () {
            // Automatic moves not supported.
            return null;
        };

        PyramidAuthority.prototype.CurrentMoveState = function () {
            if (this.CardSupply.WaitingForAnimation || this.IsGameWon())
                return MoveState.CanMove;

            if (this.GetHintInternal().Opcode == CardOp.Op.Noop && this.AllowDealNextDeck()) {

                if (this.CurrentDeal >= this.TotalDeals) {
                    return MoveState.NoMovesLeft;
                }

                return MoveState.CanDealNextDeck;
            }

            return MoveState.CanMove;
        };

        PyramidAuthority.prototype.AllowDealNextDeck = function () {
            var hint = this.GetHintInternal();

            if (!this.CardSupply.GetPile("Stock").Empty)
                return false;
            if (!this.CardSupply.GetPile("DealStock").Empty)
                return false;

            if (this.PassesThroughDeck >= PyramidAuthority.MaxPassesThroughDeck - 1
                || this.CardSupply.GetPile("Waste").Empty)
                return true;

            if(this.PassesThroughDeck < PyramidAuthority.MaxPassesThroughDeck - 1) {
                return false;
            }

            // If we already have a move available, do not show the deal button!
            if (hint.Opcode == CardOp.Op.Move
                && hint.GetPile(CardOp.eMoveParams.DestPile).Type != "Stock")
                return false;

            // Otherwise, check whether ANY card in the waste can be paired, either with an adjacent waste card, or with a tableau card
            var stockCards = this.CardSupply.GetPile("Waste").GetCards();
            for (var cardPos = stockCards.Count - 1; cardPos >= 0; cardPos--) {
                // Don't show it if we can match with the following card in the stock
                if (cardPos > 0 && stockCards[cardPos].ValueNum + stockCards[cardPos - 1].ValueNum == 13)
                    return false;

                // Check if we can match with a tableau
                for (var tableauNumber = 0; tableauNumber < 28; tableauNumber++) {
                    var tableau = this.GetTableau(tableauNumber);

                    // The tableau is not empty, is not blocked, and adds up to 13 when paired with the card under consideration: Don't show it
                    if (!tableau.Empty && !this.IsTableauBlocked(tableau) && stockCards[cardPos].ValueNum + tableau.Top.ValueNum == 13)
                        return false;
                }
            }

            // None of these conditions are met: Show the deal button!
            return true;
        };

        PyramidAuthority.prototype.ResetNoMoreMovesState = function () {
            // Do nothing.
        };

        PyramidAuthority.prototype.TriggerTip = function (e) {
            if (this.OnTip != null)
                this.OnTip(this, e);
        };

        PyramidAuthority.prototype.OnRunAction = function (action, undo, triggerTips) {
            var change = undo ? -1 : 1;

            //Track number of matches made from stock
            if (action.Ops.length == 1 && action.Ops[0].Opcode == CardOp.Op.Move) {
                var op = action.Ops[0];
                var srcPile = op.GetPile(CardOp.eMoveParams.SourcePile);
                var dstPile = op.GetPile(CardOp.eMoveParams.DestPile);
                this._currentConsecutiveCardsClearedWithStock = Math.max(0, srcPile.Type == "Stock" && dstPile.Type == "Foundation" ? this._currentConsecutiveCardsClearedWithStock + change : 0);
                this._currentWasteCardsUsed = Math.max(0, srcPile.Type == "Waste" ? this._currentWasteCardsUsed + change : 0);
            }
            else if (action.Ops.length == 2) {
                var opA = action.Ops[0];
                var opB = action.Ops[1];
                if (opA.Opcode == CardOp.Op.Move && opB.Opcode == CardOp.Op.Move) {
                    this._currentConsecutiveCardsClearedWithStock = Math.max(0, opA.GetPile(CardOp.eMoveParams.SourcePile).Type == "Stock" || opB.GetPile(CardOp.eMoveParams.SourcePile).Type == "Stock" ? this._currentConsecutiveCardsClearedWithStock + change : 0);
                    this._currentWasteCardsUsed = Math.max(0, opA.GetPile(CardOp.eMoveParams.SourcePile).Type == "Waste" || opB.GetPile(CardOp.eMoveParams.SourcePile).Type == "Waste" ? this._currentWasteCardsUsed + change : 0);
                }
            }
            this.MaxConsecutiveCardsClearedWithStock = Math.max(this.MaxConsecutiveCardsClearedWithStock, this._currentConsecutiveCardsClearedWithStock);
            this.MaxWasteCardsUsed = Math.max(this.MaxWasteCardsUsed, this._currentWasteCardsUsed);

            if (triggerTips && this.OnTip != null && !this.CheckWin() && this.GetHintInternal().Opcode == CardOp.Op.Noop && this.AllowDealNextDeck() && this.CurrentDeal < this.TotalDeals) {
                this.OnTip(this, new TipEventArgs("OutOfMoves"));
            }
        };

        PyramidAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
            if (tag == 0) {
                return;
            }
            if (undo) {
                if (((tag & TagMatch) >>> 0) != 0)
                    this.Matches--;
                if (((tag & TagRowclear) >>> 0) != 0)
                    this.RowsCleared--;
                if (((tag & TagPassthroughdeck) >>> 0) != 0)
                    this.PassesThroughDeck--;
            }
            else {
                if (((tag & TagMatch) >>> 0) != 0)
                    this.Matches++;
                if (((tag & TagRowclear) >>> 0) != 0)
                    this.RowsCleared++;
                if (((tag & TagPassthroughdeck) >>> 0) != 0)
                    this.PassesThroughDeck++;
            }

            return tag; // TODO make sure caller captures this
        };

        PyramidAuthority.prototype.OnGameOver = function (fullActionList, collapsedActionList) {

        };

        PyramidAuthority.prototype.GenerateDealData = function () {
            var i, res;
            var cardIndex = 0;

            var script = "";
            var deck = new Array(this.CardSupply.Count);

            res = this.ProcessDealDataForPile("Stock", deck, script, cardIndex);
            deck = res.deck;
            script = res.script;
            cardIndex = res.cardIndex;
            res = this.ProcessDealDataForPile("Waste", deck, script, cardIndex);
            deck = res.deck;
            script = res.script;
            cardIndex = res.cardIndex;
            res = this.ProcessDealDataForPile("Foundation", deck, script, cardIndex);
            deck = res.deck;
            script = res.script;
            cardIndex = res.cardIndex;
            for (var i = 27; i >= 0; i--) {
                res = this.ProcessDealDataForPile("Tableau" + i, deck, script, cardIndex);
                deck = res.deck;
                script = res.script;
                cardIndex = res.cardIndex;
            }

            script = "BEGIN " + script + "END";
            return new DealData(Pile.ConstructSeedFromDeck(deck, this.CardSupply.Count).toString(), script);
        };

        /// <summary>
        /// add extra deal
        /// </summary>
        /// <param name="dealsCnt"></param>
        /// <param name="logAction"> </param>
        PyramidAuthority.prototype.AddExtraDeals = function (dealsCnt, logAction) {
            if (typeof logAction == 'undefined') logAction = true;
            this.TotalDeals += dealsCnt;
            if (logAction)
                this.CardSupply.LogAction(CardAction.sParse(this.CardSupply, ["TotalExtraDeal", dealsCnt.toString()]));
        };

        PyramidAuthority.prototype.AddWildCard = function (logAction) {
            if (typeof logAction == 'undefined') logAction = true;

            var cardList = this.CardSupply.GetCardList();
            for (var i = 0; i < cardList.length; i++) {
                var card = cardList[i];
                if (card.Value == CardValue.Values.Joker && card.Suit == CardSuit.None) {
                    this.CardSupply.GetPile("Joker").AddNew(card);
                    this.CardSupply.WildCardAdded();
                    break;
                }
            }

            if (logAction)
                this.CardSupply.LogAction(CardAction.sParse(this.CardSupply, ["WildCardAdd"]));
        };

        PyramidAuthority.prototype.ApplyCurrentOptInAdBonus = function (bonusType) {
             if (bonusType == 'extraDeal')
             {
                 this.AddExtraDeals(1);
             }
             else if (bonusType == 'wildCard')
             {
                 this.AddWildCard();
             }
        };


        PyramidAuthority.prototype.ProcessDealDataForPile = function (pileName, deck, script, currentIndex) {
            var currentPile = this.CardSupply.GetPile(pileName);

            if (currentPile != null && !currentPile.Empty) {
                _.forEach(currentPile.GetCards(), function (card) {
                    deck[currentIndex++] = card.Sequence;
                });
                script = "MOVE Root " + pileName + " " + currentPile.Count + " " + script;
            }
            return {deck: deck, script: script, currentIndex: currentIndex};
        };

        PyramidAuthority.prototype.ForceDealScript = function (script) {
            this.DealScript = (script != null ? script : PyramidAuthority.DefaultDealScript);
        };


        PyramidAuthority.DefaultDealScript =
            "BEGIN " +
            "MOVE Root DealStock 52 " +

            "MOVE DealStock Tableau0 1 " +
            "MOVE DealStock Tableau1 1 " +
            "MOVE DealStock Tableau2 1 " +
            "MOVE DealStock Tableau3 1 " +
            "MOVE DealStock Tableau4 1 " +
            "MOVE DealStock Tableau5 1 " +
            "MOVE DealStock Tableau6 1 " +
            "MOVE DealStock Tableau7 1 " +
            "MOVE DealStock Tableau8 1 " +
            "MOVE DealStock Tableau9 1 " +

            "MOVE DealStock Tableau10 1 " +
            "MOVE DealStock Tableau11 1 " +
            "MOVE DealStock Tableau12 1 " +
            "MOVE DealStock Tableau13 1 " +
            "MOVE DealStock Tableau14 1 " +
            "MOVE DealStock Tableau15 1 " +
            "MOVE DealStock Tableau16 1 " +
            "MOVE DealStock Tableau17 1 " +
            "MOVE DealStock Tableau18 1 " +
            "MOVE DealStock Tableau19 1 " +

            "MOVE DealStock Tableau20 1 " +
            "MOVE DealStock Tableau21 1 " +
            "MOVE DealStock Tableau22 1 " +
            "MOVE DealStock Tableau23 1 " +
            "MOVE DealStock Tableau24 1 " +
            "MOVE DealStock Tableau25 1 " +
            "MOVE DealStock Tableau26 1 " +
            "MOVE DealStock Tableau27 1 " +
            "MOVE DealStock Stock 24 " +

            "END";

        return PyramidAuthority;

    });
